module.exports = function() {
  return new Worker(__webpack_public_path__ + "0a36414425a7a1261d63.worker.js");
};